import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex min-h-[70vh] w-full max-w-6xl flex-col items-center justify-center px-4 py-24 text-center md:px-6">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-foreground-400">
        <i className="ri-movie-2-line text-2xl"></i>
      </span>
      <p className="mt-6 text-5xl font-black text-primary-200 md:text-7xl">404</p>
      <h1 className="mt-4 text-xl font-bold text-foreground-950 md:text-2xl">没有找到这个页面</h1>
      <p className="mt-2 max-w-md text-sm text-foreground-500">
        你访问的地址 <span className="font-medium text-foreground-700">{location.pathname}</span>{' '}
        可能已被移动或不存在，不如回到首页继续浏览作品。
      </p>
      <div className="mt-6 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
        >
          返回首页
        </Link>
        <Link
          to="/category"
          className="rounded-md border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700 whitespace-nowrap"
        >
          浏览全部作品
        </Link>
      </div>
    </div>
  );
}